import React from 'react'
import { styled } from '@mui/material'
import { TableCell as BaseTableCell, Tag, Typography } from '@chilecompra/react-kit/components'

export const AbilityTag = styled(Tag)`
  &.MuiPaper-root {
    background-color: transparent;
    color: ${props => props.color === 'warning' && props.theme.palette.yellow[50]};
    height: auto;

    & > span {
      font-weight: 700;
    }
  }
`

export const Container = styled(({ children, isTiny, ...props }) => <div {...props}>{children}</div>)`
  padding: ${props => props.padding || '0'};
  margin: 0 auto;
  width: ${props => (props.isTiny === undefined || props.isTiny ? '100%' : '78%')};
`

export const Root = styled('section')`
  padding: 32px 0;
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding && `${props.padding} !important`};
  }
`
export const StatusWrapper = styled('div')`
  margin: 20px 0;
`

export const StatusItem = styled('div')`
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  border-radius: 8px;
  margin-top: 36px;
`

export const StatusIcon = styled('div')`
  min-width: 20px;
  height: 20px;
  margin-left: 20px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: ${({ icon }) => {
      switch (icon) {
        case 'tick':
          return '"✔"'
        case 'cross':
          return '"×"'
        case 'exclamation':
          return '"!"'
        case 'dash':
          return '"-"'
        default:
          return '""'
      }
    }};
    color: white;
    font-size: 15px;
    font-weight: bold;
  }
`

export const StatusText = styled('div')`
  flex-grow: 1;
`

export const StatusTypography = styled(Typography)`
  text-align: ${({ align = 'left' }) => align};
  color: ${({ color }) => color};
  min-width: 200px;
  font-size: 16px;
  @media (max-width: 480px) {
    min-width: 80px;
    font-size: 12px;
  }
`
